import script from "./TabTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./TabTemplate.vue?vue&type=style&index=0&id=fbd163e6&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd163e6"]])

export default __exports__